module.exports = __webpack_public_path__ + "static/img/sol-service.7754765.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/solution/sol-service.jpg
// module id = reA+
// module chunks = 1